import { useState } from 'react';
import { Avatar, getCat, fmt } from '../lib/helpers';
import { ExpenseDetailModal } from '../components/ExpenseDetailModal';
import { SettleUpModal } from '../components/SettleUpModal';

export function Dashboard({ people, groups, expenses, balances, meId, onDeleteExpense, onSettle }) {
  const [selected, setSelected] = useState(null);
  const [showSettle, setShowSettle] = useState(false);

  const me = people.find(p => p.id === meId);
  const myNet = balances.netTotals?.[meId] || 0;
  // myNet > 0 means I owe others; < 0 means others owe me
  const iOwe = myNet > 0 ? myNet : 0;
  const owedToMe = myNet < 0 ? -myNet : 0;
  const net = owedToMe - iOwe;

  const personById = (id) => people.find(p => p.id === id);
  const recent = [...expenses].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 8);

  const myTxns = balances.transactions?.filter(t => t.from === meId || t.to === meId) || [];

  return (
    <div className="content">
      <div className="balance-grid">
        <div className="bal-card">
          <div className="bal-label">Net balance</div>
          <div className={`bal-amount ${net > 0 ? 'text-green' : net < 0 ? 'text-red' : ''}`}>
            {net >= 0 ? '' : '-'}{fmt(net)}
          </div>
        </div>
        <div className="bal-card">
          <div className="bal-label">You are owed</div>
          <div className="bal-amount text-green">{fmt(owedToMe)}</div>
        </div>
        <div className="bal-card">
          <div className="bal-label">You owe</div>
          <div className="bal-amount text-red">{fmt(iOwe)}</div>
        </div>
      </div>

      {myTxns.length > 0 && (
        <>
          <div className="section-label" style={{ marginBottom: '0.6rem' }}>
            Suggested settlements
            <button className="btn btn-primary" style={{ padding: '4px 10px', fontSize: 12 }} onClick={() => setShowSettle(true)}>
              Settle up
            </button>
          </div>
          <div className="settle-list">
            {myTxns.map((t, i) => {
              const from = personById(t.from);
              const to = personById(t.to);
              if (!from || !to) return null;
              return (
                <div className="settle-row" key={i}>
                  <Avatar person={from} />
                  <span className="settle-name">{from.name}</span>
                  <span className="settle-arrow">→</span>
                  <Avatar person={to} />
                  <span className="settle-name">{to.name}</span>
                  <span className="settle-amount text-red">{fmt(t.amount)}</span>
                  <button className="btn" style={{ padding: '4px 10px', fontSize: 12 }}
                    onClick={() => onSettle({ from_person: t.from, to_person: t.to, amount: t.amount })}>
                    Settle
                  </button>
                </div>
              );
            })}
          </div>
        </>
      )}

      <div className="section-label" style={{ marginTop: myTxns.length > 0 ? '1rem' : 0 }}>Recent expenses</div>
      <div className="expense-list">
        {recent.length === 0 && <div className="empty">No expenses yet. Add one!</div>}
        {recent.map(exp => {
          const cat = getCat(exp.category);
          const payer = personById(exp.paid_by);
          const group = groups.find(g => g.id === exp.group_id);
          const mySplit = exp.split.find(s => s.person_id === meId);
          const iAmPayer = exp.paid_by === meId;
          const iAmSplit = !!mySplit;
          let shareLabel = '', shareClass = 'text-muted';
          if (iAmPayer && iAmSplit) {
            const lent = exp.amount - mySplit.share;
            if (lent > 0.01) { shareLabel = `you lent ${fmt(lent)}`; shareClass = 'text-green'; }
            else shareLabel = 'paid by you';
          } else if (iAmPayer) {
            shareLabel = `you lent ${fmt(exp.amount)}`; shareClass = 'text-green';
          } else if (iAmSplit) {
            shareLabel = `you owe ${fmt(mySplit.share)}`; shareClass = 'text-red';
          } else {
            shareLabel = 'not involved';
          }
          return (
            <div className="expense-row" key={exp.id} onClick={() => setSelected(exp)}>
              <div className="exp-icon" style={{ background: group ? group.color + '22' : '#eee', color: group?.color }}>
                {cat.icon}
              </div>
              <div className="exp-info">
                <div className="exp-name">{exp.name}</div>
                <div className="exp-meta">{payer?.name} paid · {exp.date} · {group?.name}</div>
              </div>
              <div className="exp-right">
                <div className="exp-total">{fmt(exp.amount)}</div>
                <div className={`exp-share ${shareClass}`}>{shareLabel}</div>
              </div>
            </div>
          );
        })}
      </div>

      {selected && (
        <ExpenseDetailModal
          expense={selected} people={people} groups={groups}
          onDelete={onDeleteExpense} onClose={() => setSelected(null)}
        />
      )}
      {showSettle && (
        <SettleUpModal
          balances={balances} people={people} meId={meId}
          onSettle={onSettle} onClose={() => setShowSettle(false)}
        />
      )}
    </div>
  );
}
